import { useState, useEffect } from "react";
import { ModalContext } from "./ModalContext";
import {
  connectWalletLocaly,
  isWalletConnected,
  disconnectWallet,
} from "../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

// const NFTAddress = "0xa6f2d6c41babea19c4ccd05ab332bc8766e4461b"
const activeChain = 5;
const NFTAddress = "0xb7f2bF7BB4B658546656b0F032fcAD05238A03e0";
const NFTABI = [
  {
    inputs: [{ internalType: "uint256", name: "_mintAmount", type: "uint256" }],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const WalletContext = ({ children }) => {
  const INFURA_ID = process.env.REACT_APP_INFURA_ID;

  const providerOptions = {
    walletconnect: {
      package: WalletConnectProvider, // required
      options: {
        rpc: {
          1: "https://mainnet.infura.io/v3/" + INFURA_ID,
          5: "https://rpc.ankr.com/eth_goerli",
          // 137: "https://matic-mainnet.chainstacklabs.com",
        },
        infuraId: INFURA_ID, // required
        // chainId: 137,
        chainId: activeChain,
      },
    },
  };

  const [connectWalletModal, setConnectWalletModal] = useState(false);
  const [account, setAccount] = useState(undefined);
  const [web3api, setWeb3api] = useState(undefined);
  const [userBalance, setUserBalance] = useState(undefined);
  const [NFTContract, setNFTContract] = useState(undefined);

  const connectWalletModalHandle = () => {
    if (!isWalletConnected()) {
      setConnectWalletModal(!connectWalletModal);
    }
  };

  const registerUser = async () => {
    setAccount(account[0]);
  };

  const connectWallet = async () => {
    const web3Modal = new Web3Modal({
      network: "mainnet",
      cacheProvider: false,
      providerOptions,
      theme: "dark",
    });
    let accounts = [];
    web3Modal
      .connect()
      .then(async (provider) => {
        const web3 = new Web3(provider);
        accounts = await web3.eth.getAccounts();
        setWeb3api(web3);
        const mintingContract = new web3.eth.Contract(NFTABI, NFTAddress);
        setNFTContract(mintingContract);
        if (!account) toast.success("Wallet connected");
        setAccount(accounts);
        // const balance = await web3.eth.getBalance(accounts[0]);
        // setUserBalance(Web3.utils.fromWei(balance, "ether"));
        //save in local storage
        if (!isWalletConnected()) {
          connectWalletLocaly(accounts[0]);
        }
      })
      .catch((err) => {
        toast.error(err.message);
        return Promise.reject("An unexpected error occurred. Please try again.");
      });
    return Promise.resolve(accounts);
  };

  const accountChangedHandler = (accounts) => {
    if (isWalletConnected() && accounts.length > 0) {
      toast.info("Account change detected");
    }
    if (accounts.length > 0) {
      setAccount(accounts);
    } else {
      disconnectWalletFromApp();
    }
  };

  const chainChangedHandler = () => {
    window.ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: `0x${activeChain}` }],
    });
  };

  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", accountChangedHandler);
      window.ethereum.on("chainChanged", chainChangedHandler);
    }
  }, []);

  const isWalletAlreadyConnected = async () => {
    if (isWalletConnected()) {
      // const accounts = await connectWallet();
      await connectWallet();
      // setAccount(accounts);
    }
  };

  const getWalletAddress = () => {
    return account ? account[0] : undefined;
  };

  const disconnectWalletFromApp = () => {
    disconnectWallet();
    setAccount(undefined);
  };

  return (
    <ModalContext.Provider
      value={{
        account,
        userBalance,
        web3api,
        NFTContract,
        isWalletAlreadyConnected,
        getWalletAddress,
        registerUser,
        disconnectWalletFromApp,
        connectWalletModalHandle,
        connectWalletModal,
        connectWallet,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default WalletContext;
